import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 mb-6" }
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "required font-semibold text-sm text-gray-800 block mb-1" }, "Nama Komisi", -1)
const _hoisted_4 = { class: "invalid-feedback text-xs text-red-500 mt-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "required font-semibold text-sm text-gray-800 block mb-1" }, "Terminal Asal", -1)
const _hoisted_6 = { class: "invalid-feedback text-xs text-red-500 mt-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "required font-semibold text-sm text-gray-800 block mb-1" }, "Kelas", -1)
const _hoisted_8 = { class: "invalid-feedback text-xs text-red-500 mt-1" }
const _hoisted_9 = { class: "flex flex-col gap-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "required font-semibold text-sm text-gray-800 block mb-1" }, "Jenis Pengeluaran", -1)
const _hoisted_11 = { class: "invalid-feedback text-xs text-red-500 mt-1" }
const _hoisted_12 = { class: "flex-1 flex flex-col" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-sm text-gray-800 block mb-1" }, "Deskripsi", -1)
const _hoisted_14 = { class: "invalid-feedback text-xs text-red-500 mt-1" }


import { Field } from 'vee-validate'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import SelectAsync from '@/views/components/form/SelectAsync.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormGeneralInfo',
  props: {
    values: null,
    errors: null
  },
  emits: ["change-name", "change-field", "blur-field"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change-name', val: string): void
  (e: 'change-field', field: any, val: any): void
  (e: 'blur-field', field: any): void
}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_unref(Field), { name: "name" }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputText), {
              id: "name",
              modelValue: __props.values.name,
              onInput: _cache[0] || (_cache[0] = (e) => emit('change-name', e.target.value)),
              onBlur: _cache[1] || (_cache[1] = () => emit('blur-field', 'name')),
              placeholder: "Nama komisi mandoran",
              class: _normalizeClass(["w-full", { 'p-invalid': __props.errors.name }])
            }, null, 8, ["modelValue", "class"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.errors.name), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _createVNode(_unref(Field), { name: "station" }, {
          default: _withCtx(() => [
            _createVNode(SelectAsync, {
              endpoint: "/management/v2/Stations",
              classname: "custom-select w-full",
              fieldLabel: (v) => v.Name,
              searchFields: ['q'],
              placeholder: "Pilih terminal asal",
              modelValue: __props.values.station,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = (val) => emit('change-field', 'station', val))
            }, null, 8, ["fieldLabel", "modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.errors.station), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_7,
        _createVNode(_unref(Field), { name: "class" }, {
          default: _withCtx(() => [
            _createVNode(SelectAsync, {
              endpoint: "/management/v2/Classes",
              searchCustom: [['isActive', '=', true]],
              classname: "custom-select w-full",
              fieldLabel: (v) => v.Name,
              searchFields: ['name'],
              placeholder: "Pilih kelas bus",
              modelValue: __props.values.class,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = (val) => emit('change-field', 'class', val))
            }, null, 8, ["fieldLabel", "modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, _toDisplayString(__props.errors.class), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", null, [
        _hoisted_10,
        _createVNode(_unref(Field), { name: "expenseType" }, {
          default: _withCtx(() => [
            _createVNode(SelectAsync, {
              endpoint: "/management/v1/MsExpensesType",
              searchCustom: [['activeOnly', '=', true]],
              classname: "custom-select w-full",
              fieldLabel: (v) => v.Name,
              searchFields: ['name'],
              placeholder: "Pilih jenis pengeluaran",
              modelValue: __props.values.expenseType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = (val) => emit('change-field', 'expenseType', val))
            }, null, 8, ["fieldLabel", "modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_11, _toDisplayString(__props.errors.expenseType), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_unref(Field), { name: "description" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Textarea), {
              id: "description",
              modelValue: __props.values.description,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = (val) => emit('change-field', 'description', val)),
              rows: "5",
              class: "w-full flex-1",
              placeholder: "Tulis deskripsi komisi"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_14, _toDisplayString(__props.errors.description), 1)
      ])
    ])
  ]))
}
}

})